/**
 * FeatureGate fallback display names.
 *
 * Existing UI source citations:
 * - frontend/src/components/settings/FollowUp/FollowUpSettingsTab.tsx:203
 * - frontend/src/types/followup-timeline.ts:41
 */
import type { FeatureKey } from './FeatureGate';

export const FEATURE_DISPLAY_NAMES = {
  churn_alert: '離脱アラート',
  follow_up: 'フォローアップ自動化',
  repeat: 'リピート作成',
} as const satisfies Partial<Record<FeatureKey, string>>;
